import React from "react";
import Styles from './styles.module.scss';
import HiwS1 from "../../components/hiwS1";
import HiwS2 from "../../components/hiwS2";
import HiwS3 from "../../components/hiwS3";
import HiwS4 from "../../components/hiwS4";



const HowItWorksPage = () => {
    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <HiwS1/>
                <HiwS2/>
                <HiwS4/>
                <HiwS3/>
            </div>
        </section>
    );
};

export default HowItWorksPage;
